import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import '@icon-park/vue/styles/index.css';

import './plugins/vantjs';

import './permission';

Vue.config.productionTip = false;

import axios from 'axios';
import request from './utils/request'

async function mountVue() {
  const setting_url = `/appsettings.json`
  const res = await axios.get(setting_url);

  Object.defineProperty(Vue.prototype, '$appsettings', {
    get() {
      return res.data
    }
  });

  request.defaults.baseURL = res.data.serverUrl + res.data.baseApi

  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}


mountVue()
